import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles, useTheme } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';

const useStyles = makeStyles(theme => ({
  appHeader: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    transition: 'all 0.3s ease',
  },
}));

const CmtHeader = props => {
  const { className, children } = props;

  const classes = useStyles();
  const theme = useTheme()

  return (
    <div>
      <AppBar position="static" className={clsx(classes.appHeader, className, 'Cmt-header')} style={{ backgroundColor: theme.palette.background.default }}>
        {children}
      </AppBar>
    </div>
  );
};

CmtHeader.defaultProps = {
  name: 'LayoutHeader',
};
CmtHeader.propTypes = {
  type: PropTypes.oneOf(['fixed', 'static']),
  fullHeader: PropTypes.bool,
};

export default CmtHeader;
